// extracted by mini-css-extract-plugin
export default {"tracker-description":"imei-info-modal_tracker-description__8b5Fp","tracker-image":"imei-info-modal_tracker-image__4VDAj","ok-button":"imei-info-modal_ok-button__GwmzF"};